import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactSection from "./sections/ContactSection";
import DovePeschiamo from "./sections/DovePeschiamo";
import SiteFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactSection />
      <DovePeschiamo />
      <SiteFooter />
    </div>;
}